import React from 'react';
import { STATE_LOGIN, STATE_RMPW, STATE_CGPW } from 'components/AuthForm';
import GAListener from 'components/GAListener';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';

// Pages
import AuthModalPage from 'pages/AuthModalPage';
import AuthPage from 'pages/AuthPage';
import DashboardPage from 'pages/DashboardPage';
import UserAdminPage from 'pages/UserAdminPage';
import UserAgentPage from 'pages/UserAgentPage';
import UserAdviserPage from 'pages/UserAdviserPage';
import UserAccessPointPage from 'pages/UserAccessPointPage';
import UserDriverPage from 'pages/UserDriverPage';
import UserVehiclePage from 'pages/UserVehiclePage';

import VehicleResidentPage from 'pages/VehicleResidentPage';
import ReportSpotPage from 'pages/ReportSpotPage';
import SpotTypesPage from 'pages/SpotTypesPage';
import ParkingSpotsPage from 'pages/ParkingSpotsPage';
import ReportAdvisorPage from 'pages/ReportAdvisorPage';
import TicketPage from 'pages/TicketPage';

import ReportCash from './pages/ReportCash';
import ReportSales from './pages/ReportSales';
import ReportWallet from './pages/ReportWallet';
import ReportFlow from './pages/ReportFlow';

import AccessPointCredit from 'pages/AccessPointCredit';
import ReportCredit from './pages/ReportCredit';
import ReportTax from './pages/ReportTax';
import ReportUnpaid from './pages/ReportUnpaid.js';

// Style CSS
import './styles/reduction.css';

// Connections
import * as loginSelectors from 'store/login/reducer';
import * as loginActions from 'store/login/actions';
import { connect } from 'react-redux';
import HistoryTransation from './pages/HistoryTransation';
import HistoricoPlaca from './pages/HistoricoPlaca';
import HistoricoReporte from './pages/HistoricoReporte';
import ReportRespect from './pages/ReportRespect';
import ReportPosPage from './pages/ReportPosPage';


const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

class MainApp extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      user: undefined
    };
    this.props.dispatch(loginActions.getUserStorage());
  }
  render(){
    if(this.props.user !== undefined && this.props.user){
      return (
        <App user={this.props.user}/>
      )
    }else{
      return (
        <BrowserRouter>
          <GAListener>
            <Switch>
              <LayoutRoute
                exact
                path="/"
                layout={EmptyLayout}
                component={
                  props => (
                    <AuthPage {...props} authState={STATE_LOGIN} />
                  )
                }
              />
              <LayoutRoute
                exact
                path="/remember-password"
                layout={EmptyLayout}
                component={
                  props => (
                    <AuthPage {...props} authState={STATE_RMPW} />
                  )
                }
              />
              <LayoutRoute
                exact
                path="/change-password/:token"
                layout={EmptyLayout}
                component={
                  props => (
                    <AuthPage {...props} authState={STATE_CGPW} />
                  )
                }
              />
              <LayoutRoute
                layout={EmptyLayout}
                component={
                  props => (
                    <AuthPage {...props} authState={STATE_LOGIN} />
                  )
                }
              />
            </Switch>
          </GAListener>
        </BrowserRouter>
      )
    }
  }
}

class App extends React.Component{
  render() {
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <Switch>
            <LayoutRoute
              exact
              path="/"
              layout={MainLayout}
              component={DashboardPage}
            />
            <LayoutRoute
              exact
              path="/user-admin"
              layout={MainLayout}
              component={UserAdminPage}
            />
            <LayoutRoute
              exact
              path="/parking-spot"
              layout={MainLayout}
              component={ParkingSpotsPage}
            />      
            <LayoutRoute
              exact
              path="/spot-types"
              layout={MainLayout}
              component={SpotTypesPage}
            />     
            <LayoutRoute
              exact
              path="/ticket"
              layout={MainLayout}
              component={TicketPage}
            />           
            <LayoutRoute
              exact
              path="/user-agent"
              layout={MainLayout}
              component={UserAgentPage}
            />
            <LayoutRoute
              exact
              path="/user-adviser"
              layout={MainLayout}
              component={UserAdviserPage}
            />
            <LayoutRoute
              exact
              path="/user-access-point"
              layout={MainLayout}
              component={UserAccessPointPage}
            />
            <LayoutRoute
              exact
              path="/user-driver"
              layout={MainLayout}
              component={UserDriverPage}
            />
            <LayoutRoute
              exact
              path="/user-vehicle"
              layout={MainLayout}
              component={UserVehiclePage}
            />
            <LayoutRoute
              exact
              path="/vehicles-resident"
              layout={MainLayout}
              component={VehicleResidentPage}
            />
            <LayoutRoute
              exact
              path="/report-spot"
              layout={MainLayout}
              component={ReportSpotPage}
            />
            <LayoutRoute
              exact
              path="/accesspoint-credit"
              layout={MainLayout}
              component={AccessPointCredit}
            />            
            <LayoutRoute
              exact
              path="/report-advisor"
              layout={MainLayout}
              component={ReportAdvisorPage}
            />
            <LayoutRoute
              exact
              path="/report-pos"
              layout={MainLayout}
              component={ReportPosPage}
            />
            <LayoutRoute
              exact
              path="/report-history"
              layout={MainLayout}
              component={HistoryTransation}
            />

            <LayoutRoute
              exact
              path="/report-cash"
              layout={MainLayout}
              component={ReportCash}
            />
            <LayoutRoute
              exact
              path="/report-sales"
              layout={MainLayout}
              component={ReportSales}
            />
            <LayoutRoute
              exact
              path="/report-wallet"
              layout={MainLayout}
              component={ReportWallet}
            />   
            <LayoutRoute
              exact
              path="/report-credit"
              layout={MainLayout}
              component={ReportCredit}
            /> 
            <LayoutRoute
              exact
              path="/report-tax"
              layout={MainLayout}
              component={ReportTax}
            />              
            <LayoutRoute
              exact
              path="/report-unpaid"
              layout={MainLayout}
              component={ReportUnpaid}
            />              

            <LayoutRoute
              exact
              path="/report-flow"
              layout={MainLayout}
              component={ReportFlow}
            />     

            <LayoutRoute
              exact
              path="/report-parking"
              layout={MainLayout}
              component={HistoricoPlaca}
            />
            <LayoutRoute
              exact
              path="/report-report"
              layout={MainLayout}
              component={HistoricoReporte}
            />               
            <LayoutRoute
              exact
              path="/report-respect"
              layout={MainLayout}
              component={ReportRespect}
            />
            <LayoutRoute
              exact
              path="/login-modal"
              layout={MainLayout}
              component={AuthModalPage}
            />
            <Redirect to="/" />
          </Switch>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }
  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }
  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }
  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }
  if (width > 1200) {
    return { breakpoint: 'xl' };
  }
  return { breakpoint: 'xs' };
};

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(componentQueries(query)(MainApp));


// WEBPACK FOOTER //
// ./src/App.js